import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";
import { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useParams } from "react-router-dom";
import ObtenerEquiposInstalados from "./ObtenerEquiposInstalados";
import Header from "components/Headers/Header";

const AsignaEquipos = () => {
  let { id, tipoOrden } = useParams();
  const [selectedOptions2, setSelectedOptions2] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [options2, setOptions2] = useState([]);
  const [postSerial, setPostSerial] = useState("");
  const [postCapacidad, setPostCapacidad] = useState(null);
  const [postFechaFabricacion, setPostFechaFabricacion] = useState(null);
  const [postPrueba, setPostPrueba] = useState(null);
  const [postUltimaPrueba, setPostUltimaPrueba] = useState(null);
  const [postInstalacion, setPostInstalacion] = useState("");
  const [postTipoEquipo, setPostTipoEquipo] = useState("");
  const [options, setOptions] = useState([]);

  // useEffect para obtener los tipos de equipo al montar el componente
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerTipoEquipos",
    })
      .then((response) => {
        const apiOptions = response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.log("Error al obtener los tipos de equipo:", error);
      });
  }, []);

  useEffect(() => {
    if (selectedOptions) {
      axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://inspecciongnvback-dev.azurewebsites.net/api/v1/EquiposPorTipo/${selectedOptions.value}`,
      })
        .then((Response) => {
          const apiOptions = Response.data.map((item) => ({
            value: item.id,
            label: item.nombre,
            tipo: item.tipo,
          }));
          setOptions2(apiOptions);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedOptions]);

  const postData = (e) => {
    e.preventDefault();

    // Validaciones según el tipo de equipo
    if (postTipoEquipo === 1) {
      if (
        !selectedOptions2.value ||
        !postSerial ||
        !postCapacidad ||
        !postInstalacion
      ) {
        alert(
          "Para el tipo de equipo 1, los campos: Equipo, Serial, Capacidad y Fecha de Instalación son obligatorios.",
        );
        return;
      }
    } else if (postTipoEquipo === 2) {
      if (!selectedOptions2.value || !postSerial) {
        alert(
          "Para el tipo de equipo 2, los campos: Equipo y Serial son obligatorios.",
        );
        return;
      }
    }

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaEquipoInstalado",
      data: {
        ordenId: id,
        equipoId: selectedOptions2.value,
        NombreEquipo: selectedOptions2.label,
        serial: postSerial,
        capacidad: postCapacidad,
        fechaFabricacion: postFechaFabricacion,
        prueba: postPrueba,
        ultimaPrueba: postUltimaPrueba,
        fechaInstalacion: postTipoEquipo === 1 ? postInstalacion : null, // Solo enviar fecha de instalación si es tipo 1
        tipoEquipo: postTipoEquipo,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Creada con éxito!");
        setSelectedOptions2([]);
        setPostSerial("");
        setPostCapacidad(null);
        setPostFechaFabricacion(null);
        setPostPrueba(null);
        setPostUltimaPrueba(null);
        setPostInstalacion("");
        setPostTipoEquipo("");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Asignación de Equipos</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    Información del Equipo a Instalar
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-city"
                          >
                            Tipo Equipo
                          </label>
                          <Select
                            name="colors"
                            options={options}
                            classNamePrefix="select"
                            onChange={(selected) => {
                              setSelectedOptions(selected);
                              setSelectedOptions2([]); // Limpia el equipo seleccionado al cambiar el tipo
                              setPostTipoEquipo(selected.value); // Guardamos el tipo de equipo
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-city"
                          >
                            Marca
                          </label>
                          <Select
                            name="colors"
                            options={options2}
                            classNamePrefix="select"
                            onChange={(selected) => {
                              setSelectedOptions2(selected);
                              setPostTipoEquipo(selected.tipo);
                            }}
                            value={selectedOptions2}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-country"
                          >
                            Serial
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-country"
                            placeholder="# de serial"
                            onChange={(e) => setPostSerial(e.target.value)}
                            type="text"
                            value={postSerial}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {postTipoEquipo === 1 && (
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Capacidad
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-country"
                              placeholder="Capacidad"
                              onChange={(e) => setPostCapacidad(e.target.value)}
                              type="text"
                              value={postCapacidad}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Fecha Instalación
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-country"
                              placeholder="Fecha Instalación"
                              onChange={(e) =>
                                setPostInstalacion(e.target.value)
                              }
                              type="date"
                              value={postInstalacion}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Fecha Fabricación
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-country"
                              placeholder="Fecha de Fabricación"
                              onChange={(e) =>
                                setPostFechaFabricacion(e.target.value)
                              }
                              type="date"
                              value={postFechaFabricacion}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Fecha Próxima Prueba
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-country"
                              placeholder="Fecha de Próxima Prueba"
                              onChange={(e) => setPostPrueba(e.target.value)}
                              type="date"
                              value={postPrueba}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-country"
                            >
                              Fecha Última Prueba
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-country"
                              placeholder="Fecha de Última Prueba"
                              onChange={(e) =>
                                setPostUltimaPrueba(e.target.value)
                              }
                              type="date"
                              value={postUltimaPrueba}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  )}

                  <button className="btn btn-info btn-lg" onClick={postData}>
                    Agregar
                  </button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <hr />
      <ObtenerEquiposInstalados OrdenId={id} tipoOrden={tipoOrden} />
    </>
  );
};

export default AsignaEquipos;
